<template>
    <div class="main-page">
        <TopBarText :title="pageTitle" />
        <div
            class="mx-auto flex-auto w-full min-h-0 flex flex-col md:border-l md:border-r page-content"
            :class="contentClass"
        >
            <slot></slot>
        </div>
        <template v-if="menuBar">
            <div class="flex-none min-w-0 bottom-nav">
                <MenuBar />
            </div>
        </template>
    </div>
</template>
<script>
//component
import TopBarText from "../TopBar/TopBarText.vue";
import MenuBar from "../MenuBar/MenuBar.vue";

export default {
    name: "MainPage",
    props: {
        pageTitle: {
            type: String
        },
        bgClass: {
            type: String,
            //default: "bg-a-gray-efefef"
        },
        menuBar: {
            type: Boolean
        }
    },
    components: {
        TopBarText,
        MenuBar
    },
    computed: {
        contentClass: function() {
            let cls = [];
            cls.push(this.bgClass);

            if (this.menuBar) {
                cls.push("has-bottom-nav");
            }
            return cls;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.main-page {
    @apply mx-auto flex flex-col w-full min-h-screen bg-a-orange-fe5000 font-main max-w-lg;

    &.has-bottom-nav {
        margin-bottom: $menubar-height;
    }

    .page-content {
        @apply rounded-t-10;
    }

    .bottom-nav {
        height: $menubar-height;
    }
}
</style>
